import OnboardingFlow from '../components/OnboardingFlow';

/**
 * Route entry for `/onboarding`. Renders {@link OnboardingFlow}, which owns
 * its own route decision (resume the flow, or redirect a fully-onboarded
 * viewer to the dashboard) and full-screen layout.
 */
const OnboardingScene = () => {
  return <OnboardingFlow />;
};

export default OnboardingScene;
